import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PartnerUnique } from '../../../../model/partner.model';
import { LogoComponent } from './logo/logo.component';
import { FacilityComponent } from './facility/facility.component';
import { ResizeObserverDirective } from '@shared/directives';
import { BehaviorSubject, debounceTime } from 'rxjs';

@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [CommonModule, TranslateModule, RouterModule, LogoComponent, FacilityComponent, ResizeObserverDirective],
})
export class ItemComponent {
    @Input({ required: true }) partnersUnique!: PartnerUnique;

    private _height$ = new BehaviorSubject<number | 'auto'>('auto');

    readonly height$ = this._height$.pipe(debounceTime(25));

    onResize(event: DOMRectReadOnly) {
        this._height$.next(event.height);
    }
}
